'use strict';

var SkillLabel_parts = require('./SkillLabel.parts.js');

const SkillLabel = {
    Root: SkillLabel_parts.Root,
    Icon: SkillLabel_parts.Icon,
    Text: SkillLabel_parts.Text
};

module.exports = SkillLabel;
